import {
  Box,
  Flex,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import { useContext, useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Product_API } from "../../../../api";
import { Data } from "../../../../pages/Context/DataContext";
import DelieveryComponent from "./DelieveryComponent";

const InputComponent = () => {
  const [input, setInput] = useState('');
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const placeholderTexts = [  "Search for medicines and wellness products…", "Find the products you need for your pharmacy…", "Order medical supplies and equipment…", "Browse our catalog for pharmaceutical products…", "Quickly locate and order in-demand items…","Discover new and popular products for your pharmacy…", "Search by product name, code, or manufacturer…", "Order supplies for your pharmacy's daily operations…", "Explore our wide range of healthcare products…", "Find the best deals on pharmaceutical products…"];
  useEffect(() => {
    const intervalId = setInterval(() => {
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholderTexts.length);
    }, 3000); // Change the interval duration as needed (in milliseconds)

    return () => clearInterval(intervalId);
  }, []);
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState([]);
  const ref = useRef(null);
  const {handlecurrProduct, getProduct} = useContext(Data)

  const handleChange = (e) => {
    setInput(e.target.value);
    console.log(e.target.value);
  }

  const handleSubmit = (e) => {
    if(e.key == "Enter"){
      navigate("/products");
      displayRelated();
    }
  }

  var displayRelated = debounce (function() {
    getProduct(input);
  },1000)
  function debounce(fn,delay) {
    let timerId;
    return function() {
        clearTimeout(timerId);
        timerId = setTimeout(function () {
            fn()
        }, delay)
    }
  }
  const showProduct = (el) => {
    setInput('');
      handlecurrProduct(el)
      navigate(`/products/${el.id}`)
  }

  return (
    <Box pos='relative'>
        <Flex bg={"white"} borderRadius="6px" width={'600px'}>
        {/* <DelieveryComponent /> */}
        <Input
          width='100%'
          fontSize="14px"
          placeholder={placeholderTexts[placeholderIndex]}
          focusBorderColor='none'
          fontWeight='bold'
          onKeyPress={(e) => handleSubmit(e)}
          onChange={(e) => handleChange(e)}
          value={input}
        />
      </Flex>
      { input.length>0 && <Box pos='absolute' className="webkit" borderTop={'1px solid #ddde0'} ref={ref} borderRadius={'0 0 6px 6px'} mt='2px' display='none' bg='#fff' w='100%' maxH='70vh' overflow={'auto'}>
        <Box w='100%'>
          {
            searchData.map(el => (
              <Box borderBottom='1px solid #dddde0' onClick={() => showProduct(el)} cursor={'pointer'} key={el.id} display='flex' mb='10px'>
                <Box  w='30%' p='5px'>
                  <Image src={el.img1 ? el.img1 : "https://i.ibb.co/gDDxhHG/ERROR-404-NO-IMG.jpg"}></Image>
                </Box>
                <Box p='5px' w='100%'>
                  <Text fontWeight={'600'} mb='-5px'>{el.title}</Text>
                  <Text fontSize={'12px'} color='#151B3999' as='i'>Mfr: {el.manufacturer}</Text>
                  <Text fontWeight={'600'} color='#ef4281' mr='5px' mt='10px'>Rs. {parseFloat(el.actual_price).toFixed(2)}</Text>
                  {
                    el.crossed_price && <Text color='#151B3999' fontWeight={'400'} textDecoration={'line-through'} fontSize={'12px'}>Rs. {parseFloat(el.crossed_price).toFixed(2)}</Text>
                  }
                </Box>
              </Box>
            ))
          }
        </Box>
      </Box>}
    </Box>
  );
};
export default InputComponent;
